import {createAction, createSlice} from "@reduxjs/toolkit"

const initialState = {
    spot:{
        isPending: false,
        error: null,
        items:[],
        query:{
            page: 1,
            pages:1,
            size:100,
            total:0,
            sort_by: 'created_at',
            order:'desc'
        },
    },
    spotItem:{
        isPending: false,
        error: null,
        items: [],
    },
    spotReport:{
        isPending: false,
        error: null,
        reportFile: null,
    }
}

const slice = createSlice({
    name: 'spot',
    initialState,
    reducers:{
        setQuery: (state, {payload}) => {
            //
        },
        fetchSpots: (state, {payload}) => {
            state.spot.isPending = true;
        },
        fetchSpotsSuccess: (state, {payload}) => {
            state.spot.items = payload.items;

            state.spot.query.total = payload.total;
            state.spot.query.page = payload.page;
            state.spot.query.size = payload.size;
            state.spot.query.pages = payload.pages;

            state.spot.isPending = false;
        },
        fetchSpotsFailure: (state, {payload}) => {
            state.spot.error = payload;
            state.spot.isPending = false;
        },


        fetchSpotById: (state, {payload}) => {
            state.spotItem.isPending = true;
        },
        fetchSpotByIdSuccess: (state, {payload}) => {
            state.spotItem.items = payload;
            state.spotItem.isPending = false;
        },
        fetchSpotByIdFailure: (state, {payload}) => {
            state.spotItem.error = payload;
            state.spotItem.isPending = false;
        },
        clearSpotsList: (state) => {
            console.log('clearSpotsList');
            state.spotItem.items = []
        },


        fetchSpotReport: (state, {payload}) => {
            state.spotReport.reportFile = null;
            state.spotReport.isPending = true;
        },
        fetchSpotReportSuccess: (state, {payload}) => {
            state.spotReport.reportFile = payload;
            state.spotReport.isPending = false;
        },
        fetchSpotReportFailure: (state, {payload}) => {
            state.spotReport.isPending = false;
        },
        clearSporReportFile: (state, {payload}) => {
            state.spotReport = initialState.spotReport;
        }
    }
});

export const spotActions = {
    setQuery: createAction("spot/setQuery"),

    fetchSpots: createAction("spot/fetchSpots"),
    fetchSpotsSuccess: createAction("spot/fetchSpotsSuccess"),
    fetchSpotsFailure: createAction("spot/fetchSpotsFailure"),

    fetchSpotById: createAction("spot/fetchSpotById"),
    fetchSpotByIdSuccess: createAction("spot/fetchSpotByIdSuccess"),
    fetchSpotByIdFailure: createAction("spot/fetchSpotByIdFailure"),
    clearSpotsList: createAction("spot/clearSpotsList"),

    fetchSpotReport: createAction("spot/fetchSpotReport"),
    fetchSpotReportSuccess: createAction("spot/fetchSpotReportSuccess"),
    fetchSpotReportFailure: createAction("spot/fetchSpotReportFailure"),
    clearSporReportFile: createAction("spot/clearSporReportFile"),
}

export default slice.reducer;